<app-modal-basic
  #baseModal
  modalContentId="consultaRapidaProdutos"
  [dialogClass]="'modal-screen'"
>
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="modal-title icofont icofont-search m-r-5"></i> Consulta rápida de produtos
    </h4>
    <button type="button" class="close basic-close" (click)="voltar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="app-modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-12 pr-0">
              <h5 style="opacity: 0.8;">Filtros</h5>
              <hr class="mt-2">
            </div>

            <app-combobox-produto
              #comboboxProduto
              [label]="'Produto/Serviço'"
              (change)="produtoChanged($event)"
              class="form-group col-12"
              formControlName="produtoId"
              [autofocus]="true"
              [startOpen]="true"
              [almoxarifadoId]="almoxarifadoSelecionadoId"
              [linhaProdutoId]="linhaDeProdutoSelecionadoId"
              appendTo="#consultaRapidaProdutos"
            >
            </app-combobox-produto>
          </div>
          <div class="row">
            <div class="col-12 pr-0">
              <h5 style="opacity: 0.8;">Consulta</h5>
              <hr class="mt-2">
            </div>

            <div class="form-group col-md-6">
              <label for="form_UnidadeMedida">Unidade Medida</label>
              <input
                id="form_UnidadeMedida"
                type="text"
                formControlName="unidadeMedida"
                class="form-control"
                readonly
              />
            </div>

            <div class="form-group col-md-6">
              <label for="form_saldoTotal" class="label-destaque"
                >Saldo Total em {{ dataAtual | date : 'dd/MM/yyyy' }}</label
              >
              <input
                id="form_saldoTotal"
                type="text"
                formControlName="saldoTotal"
                class="form-control input-destaque"
                readonly
              />
            </div>
          </div>

          <div
            class="row"
            *ngIf="this.tabelasPrecos.length > 0 || form.get('precoSemTabela').value > 0"
          >
            <div class="col-12">
              <h4 class="sub-title">Preços para venda</h4>
            </div>

            <div class="form-group col-md-6" *ngIf="form.get('precoSemTabela').value > 0">
              <label for="form_precoSemTabela" class="label-destaque">Sem tabela</label>
              <input
                id="form_precoSemTabela"
                type="text"
                formControlName="precoSemTabela"
                class="form-control"
                [options]="{ align: 'left' }"
                readonly
                currencyMask
              />
            </div>

            <div class="form-group col-sm-12" *ngIf="this.tabelasPrecos.length > 0">
              <app-dim-datatable
                [loading]="loading.request"
                [data]="tabelasPrecos"
                [columns]="colunas"
                [rowsOnPage]="10"
                [totalItems]="tabelasPrecos.length"
                [acoes]="false"
                [serverPaginated]="false"
              >
              </app-dim-datatable>

              <ng-template #elseBlock> Nenhuma tabela de preço vinculada. </ng-template>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col-12 pl-0">
              <span>&nbsp;</span>
              <hr class="mt-2">
            </div>
            <div class="form-group col-sm-6">
              <label for="almoxarifadoSelect">Almoxarifado</label>
              <ng-select
                id="almoxarifadoSelect"
                [items]="almoxarifadosList"
                bindLabel="nome"
                bindValue="id"
                [(ngModel)]="almoxarifadoSelecionadoId"
                [ngModelOptions]="{standalone: true}"
                (change)="onAlmoxarifadoChange($event)"
                placeholder="Selecione um almoxarifado"
                appendTo="#consultaRapidaProdutos"
              >
              </ng-select>
            </div>
            <div class="form-group col-sm-6">
              <label for="linhaProdutoSelect">Linha de Produto</label>
              <ng-select
                id="linhaProdutoSelect"
                [items]="linhaDeProdutoList"
                bindLabel="descricao"
                bindValue="id"
                [(ngModel)]="linhaDeProdutoSelecionadoId"
                [ngModelOptions]="{standalone: true}"
                (change)="onLinhaDeProdutoChange($event)"
                placeholder="Selecione uma linha de produto"
                appendTo="#consultaRapidaProdutos"
              >
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 pl-0">
              <span>&nbsp;</span>
              <hr class="mt-2">
            </div>

            <div class="form-group col-md-6">
              <label for="form_almoxarifadoPadrao">Almoxarifado Padrão</label>
              <input
                id="form_almoxarifadoPadrao"
                type="text"
                formControlName="almoxarifadoPadrao"
                class="form-control"
                readonly
              />
            </div>
            <div class="form-group col-md-6">
              <label for="form_linhaDeProduto">Linha de Produto</label>
              <input
                id="form_linhaDeProduto"
                type="text"
                formControlName="linhaDeProduto"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="form_estoqueMinimo">Estoque Mínimo</label>
              <input
                id="form_estoqueMinimo"
                type="text"
                formControlName="estoqueMinimo"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div *ngIf="almoxarifados && almoxarifados.length !== 0">
            <app-dim-datatable
              #table
              [data]="almoxarifados"
              [loading]="loading['table']"
              [columns]="colunasAlmoxarifados"
              [rowsOnPage]="10"
              [totalItems]="almoxarifados.length"
              [serverPaginated]="false"
              [showPagination]="false"
              [showInfoMobile]="false"
            >
            </app-dim-datatable>
          </div>
        </div>
      </div>
      <div class="form-button-row">
        <button (click)="voltar()" class="btn btn-info">
          <i class="fa fa-arrow-left"></i>
          Voltar
        </button>
      </div>
    </form>
  </div>
</app-modal-basic>
